import { c as _c } from "react/compiler-runtime";
import { useField, useFormikContext } from 'formik';
import { useContext } from 'react';
import { SourceType, SourceTypeSchema } from '../../../../../../../../typings/Integration.interface';
import { capitalizeFirstLetter, fieldName } from '../../../../../utils';
import { showChat } from '../../../../../utils/liveChat';
import Icon, { IconName } from '../../../../common/base/Icon';
import Link from '../../../../common/base/Link';
import Text from '../../../../common/base/Text';
import ItemListPickerInput from '../../../../common/Form/Fields/ItemListPicker';
import { StyledField } from '../../../../common/Form/Fields/SelectInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import { DashboardContext } from '../../DashboardContext';
export function SelectSourceType(t0) {
  const $ = _c(24);
  const {
    prefix,
    onSelect,
    help
  } = t0;
  const {
    submitCount
  } = useFormikContext();
  const {
    source_types
  } = useContext(DashboardContext);
  let t1;
  if ($[0] !== prefix) {
    t1 = fieldName("type", prefix);
    $[0] = prefix;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [field, t2] = useField(t1);
  const {
    error,
    touched
  } = t2;
  const has_error = (touched || submitCount > 0) && !!error;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justify: "space-between",
      align: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Div flex={t3}><label><Text size="xs" semi={true} muted={true}>Source Type<Text danger={true} as="span">*</Text></Text></label></Div>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== prefix) {
    t5 = fieldName("type", prefix);
    $[4] = prefix;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [{
      key: "platform",
      label: "Platform webhooks"
    }, {
      key: "http",
      label: "Generic"
    }];
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== source_types) {
    t7 = (search_team, category_0) => source_types ? `verification-methods-${search_team}-${category_0}` : "";
    $[7] = source_types;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== field || $[10] !== source_types) {
    t8 = async (search_term_0, category_1) => {
      if (!source_types) {
        return [];
      }
      const search_results = Object.entries(source_types).filter(t9 => {
        const [type, config] = t9;
        if (config.hidden && field.value !== type) {
          return false;
        }
        if (search_term_0 && !config.label.toLowerCase().includes(search_term_0.toLowerCase())) {
          return false;
        }
        if (category_1 === "all" && ["http", "platform"].includes(config.category)) {
          return true;
        }
        return category_1 === config.category;
      });
      const fallback_types_id = ["WEBHOOK", "HTTP"];
      const fallback_types = fallback_types_id.map(id => {
        const source_type = source_types[id] as SourceTypeSchema;
        return {
          ...source_type,
          label: `${source_type.label} for '${search_term_0}'`
        };
      });
      const results = search_results.length ? search_results : fallback_types.map((type_0, index) => [fallback_types_id[index], type_0] as const);
      return results.sort((t10, t11) => {
        const [, a] = t10;
        const [, b] = t11;
        if (a.category !== b.category) {
          return a.category.localeCompare(b.category);
        }
        if (!search_term_0.length && a.popular !== b.popular) {
          return a.popular ? -1 : 1;
        }
        return a.label.localeCompare(b.label);
      }).map(_temp2);
    };
    $[9] = field;
    $[10] = source_types;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== onSelect || $[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <ItemListPickerInput search_placeholder="Find a source type..." name={t5} onSelect={onSelect} outline={true} categories={t6} getItemsFooter={_temp} show_category_badge={false} getItemsKey={t7} getItems={t8} />;
    $[12] = onSelect;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== error || $[18] !== has_error || $[19] !== help) {
    t10 = has_error ? <Text m={{
      t: 1,
      b: 0
    }} size="xs" as="p" danger={true}><Icon icon="info" left={1} />{error}</Text> : <Text m={{
      t: 1,
      b: 0
    }} flex={{
      align: "center"
    }} size="xs" as="p" muted={true}><Icon icon="info" left={1} />{help || "Represents the producer of your HTTP requests."}</Text>;
    $[17] = error;
    $[18] = has_error;
    $[19] = help;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t9) {
    t11 = <StyledField large={true} block={true}>{t4}{t9}{t10}</StyledField>;
    $[21] = t10;
    $[22] = t9;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}
function _temp2(t0) {
  const [key, config_0] = t0;
  return {
    id: key,
    icon: (config_0.icon || "verification" as const) as IconName,
    label: config_0.label,
    description: config_0.description,
    category: capitalizeFirstLetter(config_0.category)
  };
}
function _temp(search_term, category) {
  const category_label = category === "http" ? "protocols" : "platforms";
  return <Text p={{
    y: 2,
    l: 3
  }} m={0} size="s" as="p" muted={true} flex={{
    align: "center",
    gap: 1
  }}>Looking for more {category_label}?<Link neutral={true} icon="link" onClick={showChat}>Request a new source type</Link></Text>;
}